/*
 * @Author: edvardchen
 * @Date:   2016-11-16 21:12:48
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2021-08-26 14:42:18
 */

// @flow
// import _ from 'lodash';
// import querystring from 'query-string';
import { connect, type MapStateToProps } from 'react-redux';
import shallowEqual from 'fbjs/lib/shallowEqual';
import * as React from 'react';
// import MD5 from 'crypto-js/md5';
// import autobind from 'core-decorators/lib/autobind';
import { type State, type Dispatch } from '../../ducks/types';
// import { makeImageVideoInfo } from '../../ducks/article';
// import { getVideoInfo4Article } from '../../fetchers/article_client';
import { url as Url, beaconReport } from '../../utility';
import { getImageExtData } from '../../utility/articleData';
import { isLoadKuaiBao, isArticleImageBtn } from '../../utility/PageConfigDataForShare';
import './ImageInArticle.scss';
import withExposureWatch from '../../HOCs/withExposureWatch_new';
// import ReportRecommend from '../../utility/reportRecommend';
// import { universalReport } from '../../utility/universalReport';
const BIG_WIDTH = 250;
// const subjectMatch = ['107', '106', '111', '180', '148']; // 主题匹配规则
type Props = {
  src: string,
  width: number,
  height: number,
  ratio: number,
  onClick: Function,
  onClickImage: Function,
  onClickArticleImageBtn: Function,
  imgExternalData: Object,
  query: Object,
  grayConfig: Object,
  dispatch: Dispatch,
  qbid?: string,
  docId: string,
  tagDefaultInfo: Array<*>,
  entry: string,
  currentChannel: string,
};
// const grayArr = ['imageVideoC'];
// const imgHost = 'http://frame4img2vid.imtt.qq.com/';
// eslint-disable-next-line new-cap
// const getMd5 = (str: string) => MD5(str).toString();
const NewImage = withExposureWatch(({ src, alt, onClick }) => (
  <img
    src={src}
    alt={alt}
    onError={errorReport}
    onLoad={onLoad}
    onClick={(el) => {
      onClick && onClick(el);
    }}
  />
));
// const ImageVideo = withExposureWatch(({ data, onClick, extClassName = '', params }) => {
//   const { src, title, subTitle } = data;
//   return (
//     <div className={`imageVideo ${extClassName}`} onClick={onClick} {...(params || {})}>
//       <div className="image">
//         <img className="imagediv" src={src} alt="" />
//         <div className="mask"></div>
//       </div>
//       <div className="textdiv">
//         <div className="text">{title}</div>
//         <div className="subtitle">{subTitle}</div>
//       </div>
//     </div>
//   );
// });
const errorReport = (event) => {
  const { currentTarget } = event || {};
  const { src, baseURI } = currentTarget || {};
  beaconReport({
    key: 'NewsImageError',
    params: {
      src,
      baseURI,
    },
  });
};
const onLoad = (image: Object) => {
  try {
    const r = Math.floor(Math.random() * 100);
    if (r === 1) {
      const { src = '' } = image || {};
      if (src) {
        const reg = /\/\d+\?/;
        let ratio = (src.match(reg) || [])[0];
        ratio = ratio && ratio.substring(0, ratio.length - 1);
        console.log(src, ratio);
        beaconReport({
          key: 'NewsImageLoad',
          params: {
            src,
            ratio,
          },
        });
      }
    }
  } catch (error) {}
};

class ImageInArticle extends React.Component<Props, *> {
  version: string;
  imageUrl: string;
  state = { videoInfo: null };
  shouldComponentUpdate(nextProps, nextState = {}) {
    return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state.videoInfo, nextState.videoInfo);
  }
  // 图搜视频组件下线
  // @autobind
  // async getVideoTagInfo(src: string) {
  //   if (typeof window === 'undefined' || !src) return;
  //   const { /* grayConfig = {},*/ width = 0 /* query: { image } = {} */ } = this.props;
  //   if (width < BIG_WIDTH) return; // 宽度限制
  //   // const grayHit = (grayConfig.imageVideo && grayConfig.imageVideo.isAble) || image === 'imageVideo'; // 实验桶判断
  //   // if (!grayHit) return;
  //   this.imageUrl = src; // 当前src赋值给this下
  //   if (window._ExpVideo && window._ExpVideo.length > 0) {
  //     // 已曝光视频判断
  //     // 每篇文章最多1个视频
  //     return;
  //   }
  //   const md5 = getMd5(src);
  //   const _url = window.location.href;
  //   const result = await getVideoInfo4Article({
  //     str: md5,
  //     imageUrl: src,
  //     url: _url,
  //   }).catch((e) => {
  //     console.debug('getVideoInfo4Article-error', e);
  //   });
  //   if (result && !_.isEmpty(result)) {
  //     this.setState({ videoInfo: Object.assign({ targetUrl: src }, result) });
  //     const { currentChannel = '' } = this.props;
  //     const { vid = '' } = result || {};
  //     const ch = isPushEntry() ? '001885' : currentChannel;
  //     ReportRecommend.qbExposure({
  //       innerCh: '121022',
  //       productId: 102,
  //       senceId: 2,
  //       ch,
  //       docId: vid,
  //       busiType: 3,
  //     });
  //   }
  //   console.log('getVideoInfo4Article', result, md5);
  // }
  // @autobind
  // reportData(type: number, vid: string, url: string) {
  //   // type 1 曝光  2 点击
  //   if (type === 1) {
  //     window.ImgVideoEXP = window.ImgVideoEXP || [];
  //     if (window.ImgVideoEXP.indexOf(vid) > -1) {
  //       return;
  //     }
  //     window.ImgVideoEXP.push(vid);
  //   }
  //   beaconReport({
  //     key: 'NewsImgVideo',
  //     params: {
  //       type,
  //       docId: this.props.docId,
  //       vid,
  //       image: url,
  //       isFlow: 1,
  //     },
  //   });
  // }
  // @autobind
  // getSecImageUrl() {
  //   const { imageUrl, vid, second } = this.state.videoInfo || {};
  //   let _url = imageUrl;
  //   if (second) {
  //     _url = `${imgHost}${vid}/${second}.jpg`;
  //   }
  //   return _url;
  // }
  // @autobind
  // getFlowUrl(vid) {
  //   const { query, currentChannel = '' } = this.props;
  //   const { extenddata = '' } = query;
  //   const ch = isPushEntry() ? '001884' : currentChannel;
  //   const innerCh = isPushEntry() ? '' : '121022';
  //   const { queryId } = querystring.parse(extenddata) || {};
  //   const extData = {
  //     log_version: 1,
  //     vid,
  //     appid: 102,
  //     ch,
  //     leadVideo: 1,
  //     ctr_scenes_id: 2,
  //     queryid: queryId,
  //     inner_ch: innerCh,
  //     busi_type: 2,
  //   };
  //   const contenturl = `http://v.html5.qq.com/#p=zxSplayer&vid=${vid}`;
  //   const flowurl = `qb://video/feedsvideo/list?vid=${vid}&ch=${ch}&sh_na_id=1007&isNeedSniff=0&contenturl=${encodeURIComponent(
  //     contenturl,
  //   )}&extinfo=${encodeURIComponent(querystring.stringify(extData))}`;
  //   console.log('openVideoFloat', flowurl);
  //   return flowurl;
  // }
  // @autobind
  // reportPV(type) {
  //   const { docId = '', query = {} } = this.props;
  //   const { vid } = this.state.videoInfo || {};
  //   const isPush = isPushEntry();
  //   const ch = isPush ? '001884' : '003801';
  //   const innerCh = isPush ? '' : '121022';
  //   const { extenddata } = query;
  //   const extData = querystring.parse(extenddata) || {};
  //   const extData2 = Object.assign(extData, {
  //     ch, // push 场景固定写 1884
  //     dataSrc: 1,
  //     data_type: 3, // 3短视频
  //     action: type,
  //     docId,
  //     senceId: 2, // 图搜视频
  //     productId: 102,
  //     vid,
  //     innerCh,
  //   });
  //   ReportRecommend.qbTerminalExposure(extData2);
  // }
  // 图搜视频组件下线
  // @autobind
  // renderImageTag() {
  //   if (this.state.videoInfo) {
  //     const { vid, title: subTitle = '', targetUrl } = this.state.videoInfo;
  //     if (!subTitle || targetUrl !== this.imageUrl) {
  //       return null;
  //     }
  //     window._ExpVideo = window._ExpVideo || []; // 已曝光视频不显示
  //     window._ExpVideo.push(vid);
  //     const text = '查看相关视频';
  //     const secimage = this.getSecImageUrl();
  //     const { grayConfig } = this.props;
  //     const extS =
  //       grayConfig.imageStretch && grayConfig.imageStretch.isAble ? 'ui_test_new_BigImage_Normal_stretch' : '';
  //     const { docId = '' } = this.props;
  //     const USRPParams = universalReport.imageVideoCard(vid, docId, 'short_video');
  //     return (
  //       <ImageVideo
  //         data={{ src: secimage, title: text, subTitle }}
  //         onClick={() => {
  //           const _url = this.getFlowUrl(vid);
  //           this.reportPV(1, vid);
  //           /* const word = query || tag || subTitle || '';
  //           if (word) {
  //             this.reportData(2, vid, targetUrl);
  //             const url = `qb://searchresult?q=${word}&tabId=88&entryScene=qb_tusou&jump_from=qb_tusou`;
  //             redirect(url);
  //           } */
  //           this.reportData(2, vid, targetUrl);
  //           redirect(_url);
  //         }}
  //         extClassName={extS}
  //         // 图搜视频曝光点击都要做上报
  //         onExposure={() => {
  //           this.reportPV(0, vid);
  //         }}
  //         onExposureExtra={() => {
  //           this.reportData(1, vid, targetUrl);
  //         }}
  //         extraRate={0.9}
  //         extraInterval={1}
  //         params={USRPParams}
  //       />
  //     );
  //   }
  //   return null;
  // }
  render() {
    const {
      width,
      ratio,
      onClick,
      onClickImage,
      onClickArticleImageBtn,
      src = '',
      imgExternalData = {},
      height,
      grayConfig = {},
    } = this.props;
    const _onClick = onClick || onClickImage;
    let style = {};
    let className = 'big';
    if (width < BIG_WIDTH) {
      style = {
        maxWidth: `${width}px`,
        maxHeight: `${height}px`,
      };
      className = 'small';
    }
    let _src = src;
    const { sText = '', sBuParam = '' } = getImageExtData(imgExternalData);
    if (_src) {
      const urlObj = Url.parse(_src, true);
      if (sBuParam) {
        urlObj.query.sBuParam = sBuParam;
        _src = Url.format(urlObj);
      }
    }

    // 智能识图和商品的识你所见css保持一致
    let text = '';
    if (sText && sBuParam) {
      text = sText;
    }
    let extS = `ui_test_new_BigImage_Normal_${className}`;
    if (grayConfig.imageStretch && grayConfig.imageStretch.isAble) {
      extS = '';
    }
    const klass = `at-content-img--box ${className} ${extS}`;

    // 图片底部按钮点击
    const isKuaibao = isLoadKuaiBao();
    const isShowArticleImageBtn = isKuaibao && isArticleImageBtn();

    let btnClass = '';
    let btnText = '打开QQ浏览器查看更多高清图';
    if (isKuaibao) {
      btnClass = 'is_kuaibao';
      btnText = '打开看点快报查看更多高清图';
    }
    const data = {
      src: _src,
      alt: '',
      errorReport,
    };
    const pBottom = `${(ratio || 0) * 100}%`;
    const showBtnKlass = `img-download-btn ${btnClass}`;
    return (
      <div className={klass} {...{ style }}>
        <div className="at-content-img--inner imgInArticle" style={{ paddingBottom: pBottom, overflow: 'hidden' }}>
          <NewImage
            {...data}
            onExposure={(el) => {
              const image = el && el.children && el.children[0];
              if (image) {
                onLoad(image);
                // this.getVideoTagInfo(image.src);
              }
            }}
            onClick={_onClick}
            extraInterval={50}
            onExposureExtra={() => {
              window._READINGDATA = window._READINGDATA || {};
              window._READINGDATA.exposureImage = window._READINGDATA.exposureImage || 0;
              window._READINGDATA.exposureImage += 1;
            }}
          />
          {text ? (
            <div className="img-identity" style={{ paddingLeft: '30px', paddingRight: '12px' }}>
              {text}
            </div>
          ) : null}
        </div>
        {/* {this.renderImageTag.bind(this)()} */}
        {isShowArticleImageBtn ? (
          <div className={showBtnKlass} onClick={onClickArticleImageBtn}>
            {btnText}
          </div>
        ) : null}
      </div>
    );
  }
}
const mStoP: MapStateToProps<State, *, *> = ({
  user: { qbid = '' } = {},
  article: { subjectId = '', docId = '', tagDefaultInfo = [] } = {},
  currentChannel = '',
  location: { query } = {},
  grayConfig = {},
  entry = '',
}) => ({
  subjectId,
  currentChannel,
  query,
  grayConfig,
  docId,
  qbid,
  tagDefaultInfo,
  entry,
});

export default connect(mStoP)(ImageInArticle);
